
export const offerStatus = {
    UnderRevision: "Under Revision",
    InConsidiration: "In Considiration",
    Accepted: "Accepted"
};

export const getOfferStatus = (benefitSelected, initiatorSelected, senttoSupplier) => {
    return senttoSupplier === true ? offerStatus.Accepted :
        benefitSelected === true || initiatorSelected === true ? offerStatus.InConsidiration : offerStatus.UnderRevision;
}